import { RequirementConfigurationType } from '../types/requirementConfiguration';

export const INITIAL_REQUIREMENT_CONFIGURATION: RequirementConfigurationType = {
  items: {
    req1: { prefix: 'UN', label: 'User Need', statuses: [{ label: 'Draft' }, { label: 'Done' }] },
    req2: { prefix: 'DI', label: 'Design Input', statuses: [{ label: 'Draft' }, { label: 'Done' }] },
    req3: { prefix: 'DO', label: 'Design Output', statuses: [{ label: 'Draft' }, { label: 'Done' }] },
  },
};
